module.exports = __webpack_public_path__ + "img/panhanying.10393528.jpg";